import {IUserPayload, IUserAccount, ISecureToken} from "../interfaces/user";
import {IAddress} from "../interfaces/address";
import {IOrder} from "../interfaces/order";
import {UserAccount} from "./user_account";
export class User {
  public account: IUserAccount;
  public addresses: IAddress[];
  public secureToken: ISecureToken;
  public orders: IOrder[];
  public payload : IUserPayload;

  constructor(payload: IUserPayload) {
    this.payload = payload;
    this.account = UserAccount.create(payload.account);
    this.addresses = payload.addresses || [];
    this.secureToken = SecureToken.create(payload.secureToken);
    this.orders = payload.orders || [];
  }
}

class SecureToken implements ISecureToken {
  public access_key: string;
  public access_secret: string;
  public verified: boolean;

  constructor(opts) {
    this.access_key = opts.access_key;
    this.access_secret = opts.access_secret;
    this.verified = opts.verified;
  }

  static create(payload?: ISecureToken) {
    const opts = {
      access_key: null,
      access_secret: null,
      verified: false
    };


    return new SecureToken(Object.assign(opts, payload));
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/user.ts